module.exports = __webpack_public_path__ + "static/media/moons_pago_tarjeta_credito.dbcd101f.svg";